import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Box, Typography, Grid, TextField, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import TabSaveButton from './TabSaveButton';

export default function ReportInfoForm(tabIndex) {
  const { control } = useFormContext();

  // 이 탭에서 관리하는 필드 경로
  const FIELD_PATHS = [
    'groupId',
    'reporter.type',
    'reporter.name',
    'reporter.phone',
    'reporter.email',
    'reportDate',
    'dateFirstRecognized',
    'dateOfMostRecentAdverseEvent',
    'reportType',
  ];

  return (
    <Box
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        보고 정보
      </Typography>

      <Grid container spacing={2}>
        {/* 1. 보고자 유형 */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            보고자 유형
          </Typography>
          <Controller
            name="reporter.type"
            control={control}
            render={({ field }) => (
              <RadioGroup row {...field}>
                <FormControlLabel value="koreanMedicineDoctor" control={<Radio />} label="한의사" />
                <FormControlLabel value="orientalPharmacist" control={<Radio />} label="한약사" />
                <FormControlLabel value="doctor" control={<Radio />} label="의사" />
                <FormControlLabel value="pharmacist" control={<Radio />} label="약사" />
                <FormControlLabel value="nurse" control={<Radio />} label="간호사" />
                <FormControlLabel value="dentist" control={<Radio />} label="치과의사" />
              </RadioGroup>
            )}
          />
        </Grid>

        {/* 이름 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="reporter.name"
            control={control}
            render={({ field }) => <TextField label="이름" fullWidth {...field} />}
          />
        </Grid>

        {/* 전화번호 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="reporter.phone"
            control={control}
            render={({ field }) => <TextField label="전화번호" fullWidth {...field} />}
          />
        </Grid>

        {/* 주소 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="reporter.email"
            control={control}
            render={({ field }) => <TextField label="E-mail" fullWidth {...field} />}
          />
        </Grid>

        {/* 2. 보고일 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="reportDate"
            control={control}
            render={({ field: { value, onChange, ...rest } }) => (
              <TextField
                label="보고일"
                placeholder="YYYYMMDD"
                fullWidth
                value={value ?? null}
                onChange={(e) => {
                  const next = e.target.value.replace(/\D/g, '').slice(0, 8);
                  onChange(next);
                }}
                inputMode="numeric"
                slotProps={{ htmlInput: { maxLength: 8 } }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData('text');
                  // 숫자 이외 포함 또는 8자리 초과는 붙여넣기 차단
                  if (/\D/.test(pasted) || pasted.replace(/\D/g, '').length > 8) {
                    e.preventDefault();
                  }
                }}
                {...rest}
              />
            )}
          />
        </Grid>

        {/* 3. 최초발생인지일 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="dateFirstRecognized"
            control={control}
            render={({ field: { value, onChange, ...rest } }) => (
              <TextField
                label="최초발생인지일"
                placeholder="YYYYMMDD"
                fullWidth
                value={value ?? null}
                onChange={(e) => {
                  const next = e.target.value.replace(/\D/g, '').slice(0, 8);
                  onChange(next);
                }}
                inputMode="numeric"
                slotProps={{ htmlInput: { maxLength: 8 } }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData('text');
                  // 숫자 이외 포함 또는 8자리 초과는 붙여넣기 차단
                  if (/\D/.test(pasted) || pasted.replace(/\D/g, '').length > 8) {
                    e.preventDefault();
                  }
                }}
                {...rest}
              />
            )}
          />
        </Grid>

        {/* 4. 이상반응 최근 확인일 */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Controller
            name="dateOfMostRecentAdverseEvent"
            control={control}
            render={({ field: { value, onChange, ...rest } }) => (
              <TextField
                label="이상반응 최근 확인일"
                placeholder="YYYYMMDD"
                fullWidth
                value={value ?? null}
                onChange={(e) => {
                  const next = e.target.value.replace(/\D/g, '').slice(0, 8);
                  onChange(next);
                }}
                inputMode="numeric"
                slotProps={{ htmlInput: { maxLength: 8 } }}
                onPaste={(e) => {
                  const pasted = e.clipboardData.getData('text');
                  // 숫자 이외 포함 또는 8자리 초과는 붙여넣기 차단
                  if (/\D/.test(pasted) || pasted.replace(/\D/g, '').length > 8) {
                    e.preventDefault();
                  }
                }}
                {...rest}
              />
            )}
          />
        </Grid>

        {/* 5. 보고유형 */}
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            보고 유형
          </Typography>
          <Controller
            name="reportType"
            control={control}
            render={({ field }) => (
              <RadioGroup row {...field}>
                <FormControlLabel value="voluntary" control={<Radio />} label="자발적 보고" />
                <FormControlLabel value="study" control={<Radio />} label="시험/연구" />
                <FormControlLabel value="unknown" control={<Radio />} label="모름" />
                <FormControlLabel value="etc" control={<Radio />} label="기타" />
              </RadioGroup>
            )}
          />
        </Grid>

        {/* 저장 버튼 */}
        <Grid size={{ xs: 12 }}>
          <TabSaveButton fieldPaths={FIELD_PATHS} label="탭 저장" index={tabIndex} />
        </Grid>
      </Grid>
    </Box>
  );
}
